export default __webpack_public_path__ + "static/media/work3.485b1a10.svg";